<div class="dropdown-container" id="{{dropdownID}}"> 
  <div class="dropdown-button" (click)="closeDropDown()">
    <div class="left-container">
      <svg class="clock-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM11 10H15V12H9V5H11V10Z" fill="#ACACAC"/>
      </svg>
      <p class="dropdown-title" [matTooltip]="label">{{label}}</p>
    </div>
    <div class="right-container">
      <img class="mr-r-6" (click)="clearValue($event)" src="../../../../assets/svgs/close_x.svg" label="clear-icon" alt="clear-icon" *ngIf="currentValue.value">
      <img class="svg-div"  src="../../../../assets/svgs/dropdown_arrow_ico.svg" [ngClass]="{'icon-revert': isOpen}" label="arrow-icon" alt="dropdown-arrow">
    </div>
  </div>
  <div class="dropdown-box" *ngIf="isOpen">
    <div class="dropdown-input-container">
      <input type="text" placeholder="Digite um valor" [(ngModel)]="currentValue.value" mask="0{10}" (change)="changeValue()" (keydown.enter)="close()">
    </div>
    <ul class="dropdown-text-list">
      <mat-radio-group [(ngModel)]="currentValue.name" (change)="changeValue()">
        <mat-radio-button class="radio-button-list" *ngFor="let item of list" [value]="item">
          {{item}}
        </mat-radio-button>
      </mat-radio-group>
    </ul>
  </div>
</div>
